// AI reading companion (VISION.md §4). Calls the local Gemma via /lib/ask.
// The response is always shown to the reader in a clearly AI-labelled block,
// kept distinct from their own words, and never auto-published under their name.

import { remoteUrl } from "./remoteConfig";

export type AiMode =
  | "explain"
  | "discuss"
  | "connect"
  | "question"
  | "research"
  | "organize";

export const AI_MODES: { id: AiMode; label: string; hint: string }[] = [
  { id: "explain", label: "Explain", hint: "meaning, references, context" },
  { id: "discuss", label: "Discuss", hint: "respond to your reaction" },
  { id: "connect", label: "Connect", hint: "links to other ideas/works" },
  { id: "question", label: "Question", hint: "study questions" },
  { id: "research", label: "Research", hint: "investigate a question" },
  { id: "organize", label: "Organize", hint: "suggest tags + themes" },
];

export async function askAI(
  mode: AiMode,
  input: {
    passage: string;
    note?: string;
    bookTitle?: string;
    bookAuthor?: string;
    signal?: AbortSignal;
  },
): Promise<string> {
  const r = await fetch(remoteUrl("/lib/ask"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      mode,
      passage: input.passage,
      note: input.note,
      book_title: input.bookTitle,
      book_author: input.bookAuthor,
    }),
    signal: input.signal,
  });
  if (!r.ok) throw new Error(`AI request failed (${r.status})`);
  const d = (await r.json()) as { answer?: string };
  const answer = (d.answer || "").trim();
  if (!answer) throw new Error("empty AI response");
  return answer;
}
